export const authPageTransition = {
  initial: {
    opacity: 0,
    y: "-10%",
  },
  in: {
    opacity: 1,
    y: 0,
    scale: 1,
  },
  out: {
    opacity: 0,
    y: "5%",
    // scale: 0.9,
  },
};

export const darkModeTransition = {
  initial: {
    opacity: 1,
    y: "-100%",
  },
  in: {
    opacity: 1,
    y: 0,
    scale: 1,
  },
  out: {
    opacity: 0,
    y: "10%",
    scale: 0.8,
  },
};

export const onBoardTransition = {
  initial: {
    opacity: 0,
    x: "-10%",
  },
  in: {
    opacity: 1,
    x: 0,
  },
  out: {
    opacity: 0,
    x: "10%",
  },
};

export const authComponentTransition = {
  // type: "tween",
  // ease: "anticipate",
  // duration: 0.4,
  // transition: "linear",
};

export const componentTransition = {
  initial: {
    opacity: 0,
    x: "-5%",
  },
  in: {
    opacity: 1,
    x: 0,
  },
  out: {
    opacity: 0,
    x: "5%",
  },
};
export const componentTransitionProp = {
  // type: "tween",
  // ease: "anticipate",
  // duration: 0.5,
  // transition: "linear",
};
